import { Link } from 'react-router-dom';
import SharkDivingImage from './assets/Shark Diving.jpg';

function SharkCageDivingPage() {
  return (
    <div className="tour-detail-page">
      <section className="hero-subpage shark-diving-hero">
        <div className="hero-content">
          <h1>Ebamba's Thrilling Shark Cage Diving</h1>
          <p>Get up close with magnificent Great White Sharks in Gansbaai, the shark capital.</p>
        </div>
      </section>

      <section className="section-spacing light-bg">
        <div className="container">
          <h2 className="text-center">Face Your Fears, Safely</h2>
          <div className="content-intro">
            <img src={SharkDivingImage} alt="Shark Cage Diving" className="tour-main-image" />
            <p>For the ultimate adrenaline rush, Ebamba Travel & Tours offers an unforgettable shark cage diving experience. Just a two-hour drive from Cape Town, Gansbaai is renowned as the Great White Shark capital of the world, providing unparalleled opportunities for safe and thrilling encounters.</p>
            <p>Our partners prioritize safety and ethical practices, ensuring you have a respectful and awe-inspiring interaction with these incredible predators. No diving experience is required, making this an accessible adventure for nearly everyone.</p>
          </div>

          <h3 className="text-center mt-5">What to Expect on Your Shark Cage Dive</h3>
          <div className="expect-grid">
            <div className="expect-item">
              <i className="fas fa-bus"></i>
              <h4>Convenient Transfers</h4>
              <p>Optional round-trip transfers from Cape Town for a hassle-free day.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-boat"></i>
              <h4>Safety Briefing & Boat Trip</h4>
              <p>Comprehensive safety briefing, wetsuit fitting, and a scenic boat ride to the dive site.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-water"></i>
              <h4>Cage Diving Experience</h4>
              <p>Spend time in a secure cage, observing Great White Sharks from inches away (no diving experience needed, breath-holding only).</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-fish"></i>
              <h4>Surface Viewing</h4>
              <p>Even if you don't dive, enjoy incredible surface viewing of the sharks from the boat's deck.</p>
            </div>
          </div>

          <h3 className="text-center mt-5">Hear From Our Happy Thrill-Seekers</h3>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p>"Absolutely incredible! Seeing the Great Whites up close was terrifying and majestic all at once. Ebamba made the booking so easy, and the crew was fantastic."</p>
              <span>– Mark T. from Canada</span>
            </div>
            <div className="testimonial-card">
              <p>"I never thought I'd do it, but the shark cage diving with Ebamba's recommendation was the highlight of my trip! Felt completely safe and totally amazed."</p>
              <span>– Chloe M. from France</span>
            </div>
          </div>

          <div className="text-center mt-5">
            <Link to="/contact" className="btn btn-primary large-btn tour-btn">Dare to Dive - Book Now!</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SharkCageDivingPage;
